/**
* Component PopupContent
*
* Display details informations about an item in a popup.
*
* Props : 
* - src (String) : image source about an item
* - alt (String) : text alternative if the image not display
* - title (String) : main title of the popup
* - section (String) : title with a bulleted list at the bottom
* - descriptions (Array) : different informations about the item in the form of a bulleted list
* 
* Intern component : 
* - MainTitle : display a title and a subtitle
*/

<template>
  <main class="popup_content">
    <div class="popup_text">
      <MainTitle 
      :title="titlepopup" background="blue"> 
    </MainTitle>
      <p class="popup_dim">
        {{ dimensions }}  {{ peoplenumber }}
      </p>
      <div class="sections_container">
        <div
          v-for="(section, sectionIndex) in sections"
          :key="sectionIndex"
          class="section_details"
        >
          <p class="title_content"> {{section.title}}</p>
          <ul>
            <li
              v-for="(desc, descIndex) in section.description"
              :key="descIndex"
            >
              {{ desc }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import MainTitle from "@/components/MainTitle.vue";
export default {
  name: "PopupContent",
  components: { MainTitle },
  props: {
    dimensions: String,
    peoplenumber: String,
   
     sections: {
      type: Array,
      required: true,
       default: () => [],
    },
    titlepopup: String
  },
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.popup_dim{
  border-bottom: 0.1rem solid rgb(213, 211, 211);
  padding-bottom: 0em;
}
.popup_content {
   background-color: white;
  padding: 1.25rem;
  max-width: 56.25rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title_content{
  font-weight: bold;
}
.popup_picture {
  width: 100%;
  max-width: 21rem;
  border-radius: 0.5px;
  object-fit: cover;
}
.popup_text {
  width: 100%;
  text-align: left;
}

.section_details {
 flex: 1 1 200px;  // au moins 200px de large, s’adapte
  min-width: 180px;
  padding: 0.6rem;
  box-sizing: border-box;

}
.sections_container {
  display: flex;
  justify-content:center; 
 gap: 3rem;  // un peu plus d’espace
  width: 100%;
  margin-top: 1rem;  
}

.popup_text h2 {
  margin-bottom: 1.3rem;
  font-size: 1.5rem;
  font-weight: 600;
}


@media (max-width: 48rem) {
  // 768px
  .sections_container {
    flex-direction: column;
    gap: 0rem;
  }
.section_details {
    flex: 1 1 100%;
    min-width: auto;
    padding-top:0.3rem;
    padding-bottom:0.3rem;
  }
.popup_content{
  padding-bottom: 0rem;
}
}
</style>
